module.exports = __webpack_public_path__ + "img/1.70d2a14d.png";